export default __webpack_public_path__ + "static/media/bg-forest.6af231b0.jpg";